export default __webpack_public_path__ + "assets/bo.svg";